var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTapeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1069.11 597.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eaeaea;}.cls-2{fill:#d3d3d3;}.cls-3{fill:#75b4d8;}.cls-4{fill:#c6c6c6;}.cls-5{fill:#ffbe31;}.cls-6{fill:#e0e0e0;}.cls-7{fill:#397cb2;}.cls-8{fill:#f2f2f2;}.cls-9{fill:#020202;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 400.38,
    cy: 132.03,
    rx: 400.38,
    ry: 132.03
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 518.99,
    cy: 131.49,
    rx: 117.54,
    ry: 47.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.45,131v.54a1.41,1.41,0,0,1,.11-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M634.27,131a1.41,1.41,0,0,1,.11.54c0,5-26,9.13-58,9.13s-58-4.09-58-9.13v82.12H636.53V131Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.07,131v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M601.64,179c-110.56,0-200.19-21.33-200.19-47.64V321H801.83V131.36C801.83,157.67,712.2,179,601.64,179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M401.45,131v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M801.81,131v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1022.72,129.88V131c0,72.92-228.81,132-511,132S.64,203.87.64,131v-1.07H0v336c0,72.91,229,132,511.47,132S1023,538.77,1023,465.86v-336Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M104.51,545.84q11.51,3.88,24.09,7.56V423.52Q116,419.86,104.51,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M248,579q11.85,1.85,24.09,3.52V452.68Q259.87,451,248,449.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M391.53,594.23q11.94.74,24.1,1.34V465.69q-12.17-.6-24.1-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M535,597.74q12.13-.13,24.1-.42V467.43q-12,.29-24.1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M678.56,590.68q12.18-1.09,24.09-2.33V458.47q-11.89,1.23-24.09,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M822.07,570.76q12.34-2.44,24.09-5.06V435.81q-11.73,2.63-24.09,5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M965.58,526.66a205.56,205.56,0,0,0,24.09-13.86V382.92a205.56,205.56,0,0,1-24.09,13.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.28,512.8a205.56,205.56,0,0,0,24.09,13.86V455.82A206.69,206.69,0,0,1,33.28,442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M176.79,565.7q11.73,2.63,24.09,5.06V499.92q-12.34-2.44-24.09-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M320.3,588.35q11.9,1.24,24.09,2.33V519.83q-12.18-1.08-24.09-2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M463.81,597.32q12,.28,24.1.42V526.9q-12.14-.15-24.1-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M607.32,595.57q12.16-.6,24.1-1.34V523.39q-11.94.74-24.1,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M750.84,582.56q12.24-1.68,24.09-3.52V508.2q-11.85,1.83-24.09,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M894.35,553.4q12.57-3.66,24.09-7.56V475q-11.51,3.9-24.09,7.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1069.11 379.98 1007.92 416.48 1007.92 262.98 1069.11 226.49 1069.11 379.98"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapeWhite);
export default __webpack_public_path__ + "static/media/tape-white.b725773b8a1e8819edfa488f4026103f.svg";
export { ForwardRef as ReactComponent };